import { render, staticRenderFns } from "./AiChatBubble.vue?vue&type=template&id=85dd5262&scoped=true"
import script from "./AiChatBubble.vue?vue&type=script&lang=js"
export * from "./AiChatBubble.vue?vue&type=script&lang=js"
import style0 from "./AiChatBubble.vue?vue&type=style&index=0&id=85dd5262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd5262",
  null
  
)

export default component.exports